/* -----------------Globals--------------- */
import { Dialog } from "react-native-paper";

/* -----------------Types--------------- */
import type { FeedbackParams } from "../types";

import {
	DialogWrapper,
	FEEDBACK_TOAST_DURATION_MS,
	useToast,
} from "@memorang/ui";
/* -----------------Child components--------------- */
import { FeedbackContent } from "./FeedbackContent";

import { useTranslation } from "react-i18next";

interface Props {
	title?: string;
	subtitle?: string;
	visible: boolean;
	onDismiss: () => void;
	handleTracking: () => void;
	feedbackDialogParams: FeedbackParams;
	subtitleSuffix?: string;
	feedbackPlaceholder?: string;
	icon?: string;
	cta?: string;
}

const FeedbackDialog = ({
	title,
	subtitle,
	visible,
	onDismiss,
	handleTracking,
	feedbackDialogParams,
	subtitleSuffix,
	feedbackPlaceholder,
	icon,
	cta,
}: Props) => {
	const { showToast } = useToast();
	const { t } = useTranslation();

	return (
		<DialogWrapper visible={visible} handleClose={onDismiss} maxWidth="xs">
			{icon && <Dialog.Icon icon={icon} />}
			<Dialog.Title
				style={{
					textAlign: "center",
				}}
			>
				{title || t("dialog.feedback.title")}
			</Dialog.Title>
			<Dialog.Content>
				<FeedbackContent
					feedbackDialogParams={feedbackDialogParams}
					handleTracking={handleTracking}
					onDismiss={onDismiss}
					subtitle={subtitle}
					subtitleSuffix={subtitleSuffix}
					feedbackPlaceholder={feedbackPlaceholder}
					showFeedbackConfirmationToast={() =>
						showToast({
							message: "Thank you for your feedback!",
							duration: FEEDBACK_TOAST_DURATION_MS,
						})
					}
					cta={cta}
				/>
			</Dialog.Content>
		</DialogWrapper>
	);
};

export { FeedbackDialog };
